import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class NavbarService {

  private detalle$ = new BehaviorSubject<String>('0');
  selectedDetalle$ = this.detalle$.asObservable();

  setDetalle(detalle: String) {
    this.detalle$.next(detalle);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/navbar/navbar.service.ts